import React, { useEffect, useState } from 'react';
import {  KoButton,  KoLoader, KoModal, KoPagination, KoSearch, KoTable, KoTitle, KoTooltips } from 'packages';
import ProductObject from './constant';
import KoIcon from '@kwapio/icons';
import styles from './customers.module.scss';
import AddCustomer from './curd/addCustomer';
import CustomerDetails from './curd/customerDetails';
import { Form } from 'antd';



export default function Customers() {
  const [form] = Form.useForm(); // Add this line to define the form
  const [isAddCustomer,setAddCustomer]=useState(false);


  const [isloading,setLoading]=useState(false);
  const [totalCount ] = useState(0);
  const [isCustomerDetails,setCustomerDetails]=useState(false);
  const [currentRecord, setCurrentRecord] = useState();
  const [pagination, setPagination ] = useState({
    size: 100,
    page: 1
  });

  useEffect(() => {
    setLoading(true);
    setLoading(false);
  }, []
  );

  const onPagination = (page, other) => {
    const query = {
      size: other,
      page: page,
      offset: (page - 1) * other
    };
    const pQuery = Object.assign(pagination, query);
    setPagination(pQuery);
  };

  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 40,
    render: (data, row) => (
      <div className={`${styles.table} tableBtn columnsRight`} >
        <KoTooltips title={'New Window'}>
          <KoButton
            size="small"
            onClick={() => setCustomerDetails(true)}
            onClose={()=>setCustomerDetails(false) }
            className={'btn'}
            iconBtn={true}
            icon={<KoIcon width={14} height={14} name={'OpenOutlined'} />}
          />
        </KoTooltips>
        <KoTooltips title={'Edit'}>
          <KoButton
            size="small"
            className={'btn'}
            iconBtn={true}
            icon={<KoIcon width={14} height={14} name={'EditOutlined'} />}
          />
        </KoTooltips>
        <KoTooltips title={'Delete'}>
          <KoButton
            size="small"
            className={'btn'}
            iconBtn={true}
            icon={<KoIcon width={14} height={14} name={'DeleteOutlined'} />}
          />
        </KoTooltips>
      </div>
    )
  }];

  return (
    <div className={`${styles.wrapper} profileSection`}>
      {isloading && <KoLoader />}
      <div className={`tableCard`}>
        <div className={styles.tableHeader}>
          <KoTitle text='Customer Details' level={5}/>
          <KoSearch/>
        </div>
        <KoTable
          extraColumnsRight={columnsRight}
          maxHeight={80}
          data={{ columns: ProductObject.PRO_ITEMS_COLUMNS, rows: ProductObject.ROWS }}
        />

        <KoModal
          title="Add Customer"
          centered
          open={isAddCustomer}
          afterClose={() => {setCurrentRecord();}}
          handleOk={() => { setCurrentRecord(); setAddCustomer(false); }}
          onClose={() => { setCurrentRecord(); setAddCustomer(false); }}
          width={'40vw'}
          maskClosable={false}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => setAddCustomer(!isAddCustomer)} />,
            <KoButton key='create' loading={isloading} type='primary' label={`${currentRecord?.collectionId ? 'Update' : 'Add'}`} onClick={() => form.submit()} />
          ]}
        >
          {isloading ? <KoLoader circle={false} /> : <AddCustomer />}
        </KoModal>

        <KoModal
          title="Customer Details"
          centered
          open={isCustomerDetails}
          afterClose={() => {setCustomerDetails(false); }}
          handleOk={() => { setCustomerDetails(false); }}
          onClose={() => { setCustomerDetails(false); }}
          width={'80vw'}
          maskClosable={false}
          footer={null}
        >
          {isloading ? <KoLoader circle={false} /> : <CustomerDetails />}
        </KoModal>

        <KoPagination current={parseInt(pagination.page) || 1}
          total={totalCount}
          showTotal={(total, range) =>
              `${range[0]}-${range[1]} of ${total} records`
          }
          pageSize={pagination.limit}
          defaultCurrent={pagination.page}
          onChange={onPagination}
          showQuickJumper={false}
          simple={false}
          responsive={false} />
      </div>
    </div>
  );
}


